export default {"src":"/_next/static/media/users-icon.fad2b602.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};